module.exports = __webpack_public_path__ + "static/historia_ma_glos-093a5dacb210e207febe76e553ad256b.jpg";